import React from 'react'


function HomeAltLayout({children})
{

    return(

            <div style={{fontFamily: 'MavenPro', backgroundImage: `url(${require("../assets/entry.png")})`, backgroundRepeat: 'no-repeat', backgroundSize: '90% 100%'}} className='md:flex md:py-10 shadow-lg h-[100vh]'>
                <div className='flex justify-center rounded-bl-3xl ml-[0.9px]  md:hidden bg-cover' style={{backgroundImage: `url(${require("../assets/mounts.jpg")})`}}>
                    <img src={require('../assets/RAFCE-logo-white.png')} alt='logo' style={{ width:'50%',height: '10rem'}}/>
                </div>
            
                <div className=' md:w-[50%] bg-cover rounded-l-3xl'>
                    <div className='hidden md:flex items-center justify-center h-[100%]'>
                    <img src={require('../assets/RAFCE-logo-white.png')} alt='logo' className='w-[60%]'/>
                    </div>
                </div>
       
                <div className='w-full p-10 md:mx-20 md:w-[50%]'>
                {children}
                </div>
            </div>

        
    )
}

export default HomeAltLayout;